import React from "react";

const NoMessageArrow = () => (
  <svg
    width="68"
    height="112"
    viewBox="0 0 68 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.4993 2.50069L56.0551 0.962836L60.4454 11.6427L67.4993 2.50069ZM14.3088 109.912C1.85287 92.756 -0.708409 73.1941 6.71235 54.8535C14.1457 36.4818 31.6516 19.2069 59.5772 6.83807L58.7673 5.00941C30.5173 17.5219 12.5406 35.1166 4.85836 54.1033C-2.83643 73.1212 -0.146209 93.4067 12.6904 111.087L14.3088 109.912Z"
      fill="#CCDCF7"
    />
  </svg>
);
NoMessageArrow.defaultProps = {
  className: "",
  color: "",
};

export default NoMessageArrow;
